import { type AllianceRank, RANK_ORDER } from '@stars-and-ships/api-types';

export const ALLIANCE_TABS = ['overview', 'members', 'attacks', 'recruiting', 'settings'] as const;
export type AllianceTab = (typeof ALLIANCE_TABS)[number];

/**
 * Recruiting and Settings only appear for ranks the server lets act there (Warlord and up). On
 * desktop the Overview tab shows the members next to it (Tim, 2026-09-18), so Members has no tab.
 * Attacks (shared attacks, G-70) is there for every member.
 */
export const allianceTabs = (
  rank: AllianceRank,
  { desktop = false }: { desktop?: boolean } = {}
): AllianceTab[] =>
  (RANK_ORDER[rank] >= RANK_ORDER.warlord
    ? [...ALLIANCE_TABS]
    : (['overview', 'members', 'attacks'] as AllianceTab[])
  ).filter((t) => !(desktop && t === 'members'));

export const parseAllianceTab = (
  value: string | null,
  visible: readonly AllianceTab[]
): AllianceTab => visible.find((t) => t === value) ?? 'overview';
